import type {
  ApplyResetPasswordRequest,
  ChangePasswordPayload,
  ConnectRequest,
  ConnectResponse,
  LoginRequest,
  RegisterRequest,
  ResetPasswordPayload,
  TokenResponse,
} from "./model"
import { updateTokens } from "./slice"
import baseApi from "@/base/baseApi"

const api = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation<TokenResponse, LoginRequest>({
      query: (body) => ({
        url: "security/login",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          dispatch(updateTokens(data))
        } catch {
          // noop
        }
      },
    }),
    connectOauth: build.mutation<ConnectResponse, ConnectRequest>({
      query: ({ provider, ...body }) => ({
        url: `oauth/connect/${provider}`,
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
    }),
    register: build.mutation<TokenResponse, RegisterRequest>({
      query: (body) => ({
        url: "register",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          dispatch(updateTokens(data))
        } catch {
          // noop
        }
      },
    }),
    requestResetPassword: build.mutation<void, ResetPasswordPayload>({
      query: (body) => ({
        url: "request-reset-password",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
    }),
    applyResetPassword: build.mutation<
      TokenResponse,
      ApplyResetPasswordRequest
    >({
      query: (body) => ({
        url: "apply-reset-password",
        method: "POST",
        body,
      }),
      extraOptions: { withoutAuth: true },
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled

          dispatch(updateTokens(data))
        } catch {
          // noop
        }
      },
    }),
    applyVerifyEmail: build.mutation<void, Record<string, string>>({
      query: (params) => ({
        url: "verify-email",
        method: "POST",
        params,
      }),
      extraOptions: { withoutAuth: true },
    }),
    changePassword: build.mutation<void, ChangePasswordPayload>({
      query: (body) => ({
        url: "change-password",
        method: "POST",
        body,
      }),
    }),
    logout: build.mutation<void, string>({
      query: (payload) => ({
        url: "security/invalidate",
        method: "POST",
        body: { refreshToken: payload },
      }),
    }),
  }),
})

export const {
  useLoginMutation,
  useConnectOauthMutation,
  useRegisterMutation,
  useRequestResetPasswordMutation,
  useApplyResetPasswordMutation,
  useApplyVerifyEmailMutation,
  useChangePasswordMutation,
  useLogoutMutation,
} = api
